export default __webpack_public_path__ + "static/media/BannerPrincipal.77472c6b.png";